export { getResolvedThemeColors, getThemeExportColors, isLightTheme } from "./export-colors.ts";
export {
	initTheme,
	onThemeChange,
	setTheme,
	setThemeInstance,
	stopThemeWatcher,
	theme,
} from "./global-theme.ts";
export { SYSTEM_THEME_NAME } from "./system-theme.js";
export {
	detectColorFgBgTheme,
	detectTerminalTheme,
	getTerminalTheme,
	markTerminalColorsPending,
	setTerminalColorScheme,
	setTerminalColors,
} from "./terminal-colors.js";
export {
	detectTerminalBackgroundFromEnv,
	detectTerminalBackgroundTheme,
	detectTerminalThemeForAuto,
	getDefaultTheme,
	getThemeForRgbColor,
	parseAutoThemeSetting,
	resolveThemeSetting,
	type TerminalAutoThemeDetectionOptions,
	type TerminalAutoThemeDetector,
	type TerminalBackgroundThemeDetectionOptions,
	type TerminalBackgroundThemeDetector,
	type TerminalTheme,
	type TerminalThemeDetection,
	type TerminalThemeDetectionOptions,
} from "./terminal-detection.ts";
export { Theme, type ThemeBg, type ThemeColor } from "./theme-class.ts";
export {
	getAvailableThemes,
	getAvailableThemesWithPaths,
	getThemeByName,
	loadThemeFromContent,
	loadThemeFromPath,
	setRegisteredThemes,
	type ThemeInfo,
} from "./theme-loading.ts";
export {
	getEditorTheme,
	getLanguageFromPath,
	getMarkdownTheme,
	getSelectListTheme,
	getSettingsListTheme,
	highlightCode,
} from "./tui-theme.ts";
